import React from 'react';

import { Flex, Label, TextInput } from '@sopranodesign/pulse-components';

import { useVariable } from '../../../../hooks/index';

const StringDefaultValueInput = () => {
  const variable = useVariable();

  const handleDefaultValueChange = event => {
    const value = event.target.value;

    variable.dispatch({
      type: variable.TYPES.UPDATE_DEFAULT_VALUE,
      defaultValue: value
    });
  };

  return (
    <Flex col>
      <Label htmlFor="default">Default value</Label>
      <TextInput
        id="default"
        value={variable.variable.default_value}
        onChange={handleDefaultValueChange}
        placeholder="My default value"
      />
    </Flex>
  );
};

export default StringDefaultValueInput;
